import React from 'react';
import { Typography, Button } from '@material-ui/core';
import { informationColors } from '../../../themes';
import { createHistory, hasPermission, formatDate } from '../../sc-utilities';
import { parseURL } from '../../sc-utilities';

export const imeisAndSerialNumber = (rowData, translations) => (<>
    <Typography variant="subtitle1" key={`${rowData.ProductID}_serial_number`} style={{ fontSize: 12 }}
        gutterBottom> {truncateString(rowData?.SerialNumber, 35)}</Typography>
    {rowData?.MobileProduct?.IMEI ? <Typography variant="subtitle1" key={`${rowData?.ProductID}_imei`} style={{ fontSize: 12 }}
        gutterBottom>{translations['imei'] || 'IMEI'}: {rowData?.MobileProduct?.IMEI}</Typography> : null}
    {rowData?.MobileProduct?.IMEI2 ? <Typography variant="subtitle1" key={`${rowData?.ProductID}_imei_2`} style={{ fontSize: 12 }}
        gutterBottom>{translations['imei_2'] || 'IMEI 2'}: {rowData?.MobileProduct?.IMEI2}</Typography> : null}
</>)

export const truncateString = (str, size) => {
    return str?.length > size ? str.substring(0, size) + '...' : str;
}

export const isNumeric = (value) => {
    if (value !== 0 || value !== '0')
        return /^-?\d+$/.test(value);
};
export const getQueryFromObject = obj => {
    let newQuery = '';
    for (var o in obj) {
        if (!obj[o] || obj[o].length === 0) {
            continue;
        }
        if (newQuery.length === 0) {
            newQuery += `?${o}=${obj[o]}`;
            continue;
        }
        newQuery += `&${o}=${obj[o]}`;
    }
    return newQuery;
};

export const createOrAppendUrl = async obj => {
    let url = parseURL(window.location.href);
    if (!url) {
        url = {};
    }
    url = { ...url, ...obj }

    let newUrl = window.location.href.split('?')[0];
    let query = getQueryFromObject(url);
    window.history.pushState({ path: `${newUrl}?${query}` }, '', `${newUrl}${query}`);
};
export const listStyle = {
    "@global": {
        "[class*='MuiTableCell-root MuiTableCell-body']": {
            height: "40px",
            padding: '2px',
            fontSize: '0.7rem'
        },
        "[class*='.MuiButton-root']": {
            minWidth: '24px',
            borderRadius: '1px'
        },
    },
    title: {
        marginLeft: 14,
        width: "900px",
        paddingTop: '4px'
    },
    tableTitle: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        overflow: 'visible',
        paddingTop: '4px'
    },
    tableTitleRefresh: {
        marginBottom: '32px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        overflow: 'visible',
    },
    customTooltip: {
        marginLeft: -16
    },
    filters: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center"
    }
};

export const saveTableViewStyle = (theme) => {
    return {

        dialogPaper: {
            minHeight: '10vh',
            maxHeight: '70vh',
            minWidth: '80vh'
        },
        title: {
            marginTop: theme.spacing(2),
            textAlign: 'center'
        },
        submit: {
            textTransform: 'none',
            color: theme.palette.buttonText.default,
            backgroundColor: theme.palette.primary.main,
            borderRadius: '1px',
            '&:hover': {
                backgroundColor: theme.palette.secondary.main,
            },
            width: "25%",
            marginTop: "10px",
            marginLeft: '21.7rem'
        },
        cancel: {
            textTransform: 'none',
            color: theme.palette.buttonText.default,
            backgroundColor: theme.palette.primary.main,
            borderRadius: '1px',
            '&:hover': {
                backgroundColor: theme.palette.secondary.main,
            },
            width: "25%",
            marginTop: "10px"
        },
        buttonDisplay: { marginTop: '1.7rem' },
        formControl: {
            width: "22%",
            margin: theme.spacing(2),
            marginLeft: theme.spacing(0),
        },
    }
}

export const indexStyle = (theme) => {
    return {
        "@global": {
            "[class*='buttonsCustomer']": {
                margin: theme.spacing(),
                fontSize: '13px',
                width: '100%',
                '&:hover': {
                    backgroundColor: theme.palette.secondary.main,
                    color: theme.palette.buttonText.default
                },
            },
            "[class*='.MuiButton-root']": {
                minWidth: '24px',
                borderRadius: '1px'
            },
            "[class*='paletteButtons']": {
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.buttonText.default,
                margin: theme.spacing(),
                minWidth: '24px',
                borderRadius: '1px',
                '&:hover': {
                    backgroundColor: theme.palette.secondary.main,
                },
            },
        },
        root: {
            width: `98.9%`,
            height: 'auto',
            paddingTop: theme.spacing(),
            paddingLeft: theme.spacing(),
            [theme.breakpoints.down('sm')]: {
                padding: 0,
                margin: 0,
                width: '100%'
            }
        },
        remote: {
            textDecoration: 'none',
            color: 'white'
        },
        chip_NotErased: {
            color: theme.palette.warning.dark,
            padding: 1,
            fontSize: 12
        },
        chip_InProgress: {
            color: theme.palette.customInProgress.dark,
            padding: 1,
            fontSize: 12
        },
        chip_Error: {
            color: theme.palette.error.dark,
            padding: 1,
            margin: 1,
            fontSize: 12
        },
        chip_Warning: {
            color: theme.palette.error.light,
            padding: 1,
            fontSize: 12
        },
        chip_Aborted: {
            color: theme.palette.aborted.main,
            padding: 1,
            fontSize: 12
        },
        chip_Erased: {
            color: theme.palette.success.dark,
            padding: 1,
            fontSize: 12
        },
        chip_Started: {
            color: theme.palette.primary.main,
            padding: 1,
            fontSize: 12
        },
        wipeProgress: {
            padding: '10px'
        },
        paletteButtons: {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.buttonText.default,
            margin: theme.spacing(),
            minWidth: '24px',
            borderRadius: '1px',
            '&:hover': {
                backgroundColor: theme.palette.secondary.main,
            },
        },
        linearColorPrimary: {
            backgroundColor: theme.palette.info.light,
        },
        linearBarColorPrimary: {
            backgroundColor: theme.palette.info.dark,
        },
        textField: {
            marginLeft: 10
        },

        storage_WipeMethod: {
            fontSize: 12
        },
        buttonsCustomer: {
            color: theme.palette.primary.main,
            margin: theme.spacing(1),
            fontSize: '13px',
            width: '100%',
            '&:hover': {
                backgroundColor: theme.palette.secondary.main,
            },
        },
        loadingScreen: {
            backgroundColor: "transparent",
            boxShadow: "none",
        },
    }
};

export const filterQuery = filters => {
    let obj = {};
    for (var filter of filters) {
        obj[filter.column.field] = filter.value;
    }
    return obj;
}

export const capitalize = (s) => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
};

export const CustomChip = props => {
    const { keyValue, value, className } = props;
    let possibleStyles = {
        chip_Erased: {
            color: informationColors.success.dark,
            padding: 1,
            fontSize: 12
        },
        chip_NotErased: {
            color: informationColors.warning.dark,
            padding: 1,
            fontSize: 12
        },
        chip_InProgress: {
            color: informationColors.customInProgress.dark,
            padding: 1,
            fontSize: 12
        },
        chip_Error: {
            color: informationColors.error.dark,
            padding: 1,
            margin: 1,
            fontSize: 12
        },
        chip_Warning: {
            color: informationColors.warning.light,
            padding: 1,
            fontSize: 12
        },
        chip_Aborted: {
            color: informationColors.aborted.main,
            padding: 1,
            fontSize: 12
        },
        chip_NotStarted: {
            color: informationColors.info.dark,
            padding: 1,
            fontSize: 12
        },
        chip_Started: {
            color: informationColors.started.main,
            padding: 1,
            fontSize: 12
        },
    }
    return (
        <Typography key={keyValue} className={className} style={possibleStyles[className]}>{capitalize(value)}</Typography>
    );
};

export const createPaletteActionForProduct = (statistic, paletteType, classes, customerID, name, permissions) => {
    return statistic ?
        <Button color='primary'
            key={statistic} variant="contained" className={classes.paletteButtons} value={statistic}
            size='small' onClick={event => {
                switch (paletteType) {
                    case 'MobileProduct':
                        return hasPermission(permissions, 'product_list') ? goToMobileProduct(event, customerID, name) : null
                    case 'PCProduct':
                        return hasPermission(permissions, 'product_list') ? goToPcProduct(event, customerID, name) : null
                    case 'DisplayProduct':
                        return hasPermission(permissions, 'product_list') ? goToDisplayProduct(event, customerID, name) : null
                    case 'StorageProduct':
                        return hasPermission(permissions, 'product_list') ? goToStorageProduct(event, customerID, name) : null;
                    default:
                        return null;
                }
            }}>
            {statistic}
        </Button> : '[empty]';
}

export const getModel = product => {
    switch (product.Type) {
        case 'MobileProduct':
            return product && product.MobileProduct ? product.MobileProduct.MobileProductModel : '-';
        case 'PCProduct':
            return product && product.PCProduct ? product.PCProduct.Name : '-';
        case 'StorageProduct':
            return product && product.Components && product.Components[0] && product.Components[0].ComponentModel ? product.Components[0].ComponentModel : '-';
        default:
            return 'Unknown';
    }
};

export const goToColli = (event, customerID, name, setRedirectOptions, redirectOptions, activeCustomer) => {
    let colliInventoryID = event?.currentTarget?.value;
    if (customerID !== activeCustomer) {
        setRedirectOptions({ ...redirectOptions, open: true, product: name, customerID: customerID });
        return;
    }
    createHistory();
    setRedirectOptions({
        ...redirectOptions,
        redirect: true,
        redirectPath: `/logistic/container?ColliInventoryID=${colliInventoryID}`
    });
}

export const goToOrder = (event, customerID, name, activeCustomer, redirectOptions, setRedirectOptions) => {
    let orderInventoryID = event.currentTarget.value;
    if (customerID !== activeCustomer) {
        setRedirectOptions({ ...redirectOptions, open: true, product: name, customerID: customerID });
        return;
    }
    createHistory();
    setRedirectOptions({
        ...redirectOptions,
        redirect: true,
        redirectPath: `/logistic/orders?OrderInventoryID=${orderInventoryID}`
    });
};

export const goToTransportColli = (event, customerID, name, activeCustomer, redirectOptions, setRedirectOptions) => {
    let transportColliInventoryID = event.currentTarget.value;
    if (customerID !== activeCustomer) {
        setRedirectOptions({ ...redirectOptions, open: true, product: name, customerID: customerID });
        return;
    }
    createHistory();
    setRedirectOptions({
        ...redirectOptions,
        redirect: true,
        redirectPath: `/logistic/transport-container?TransportColliInventoryID=${transportColliInventoryID}`
    });
};

export const goToMobileProductPage = (event, customerID, name, activeCustomer, redirectOptions, setRedirectOptions) => {
    let mobileProductInventoryID = event.currentTarget.value;
    if (customerID !== activeCustomer) {
        setRedirectOptions({ ...redirectOptions, open: true, product: name, customerID: customerID });
        return;
    }
    createHistory();
    setRedirectOptions({
        ...redirectOptions,
        redirect: true,
        mobileProductInventoryID: event.currentTarget.value,
        redirectPath: `/mobile-product/details?productID=${mobileProductInventoryID}&type=MobileProduct`
    });
};

export const goToStorageProductPage = (event, customerID, name, activeCustomer, redirectOptions, setRedirectOptions) => {
    let storageProductInventoryID = event.currentTarget.value;
    if (customerID !== activeCustomer) {
        setRedirectOptions({ ...redirectOptions, open: true, product: name, customerID: customerID });
        return;
    }
    createHistory();
    setRedirectOptions({
        ...redirectOptions,
        redirect: true,
        redirectPath: `/storage-product/details?productID=${storageProductInventoryID}&type=StorageProduct`
    });
};

export const goToPcProductPage = (event, customerID, name, activeCustomer, redirectOptions, setRedirectOptions) => {
    let pcProductInventoryID = event.currentTarget.value;
    if (customerID !== activeCustomer) {
        setRedirectOptions({ ...redirectOptions, open: true, product: name, customerID: customerID });
        return;
    }
    createHistory();
    setRedirectOptions({
        ...redirectOptions,
        redirect: true,
        redirectPath: `/pc-product/details?productID=${pcProductInventoryID}&type=PCProduct`
    });
};

export const redirectToCustomer = (id, redirectOptions, setRedirectOptions) => {
    createHistory();
    setRedirectOptions({
        ...redirectOptions,
        redirect: true,
        redirectPath: `/admin/customers/details?customerID=${id}`
    });
};
export const createOrderQuery = (field, orderByDirection) => {
    switch (field) {
        case 'WipeStatus':
            return [{ field: 'Components.StorageComponents.WipeStatus', direction: orderByDirection }];
        case 'VerificationStatus':
            return [{ field: 'Components.StorageComponents.VerificationStatus', direction: orderByDirection }];
        case 'DiagnoseSessionCases':
            return [{ field: 'DiagnoseSessions.DiagnoseSessionCases', direction: orderByDirection }];
        case 'WipeMethod':
            return [{ field: 'Components.StorageComponents.WipeMethod', direction: orderByDirection }];
        case 'WipeStarted':
            return [{ field: 'Components.StorageComponents.WipeStarted', direction: orderByDirection }];
        case 'VerificationStarted':
            return [{ field: 'Components.StorageComponents.VerificationStarted', direction: orderByDirection }];
        case 'TransportColliInventoryID':
            return [{ field: 'TransportColli.TransportColliInventoryID', direction: orderByDirection }];
        case 'OrderInventoryID':
            return [{ field: 'Order.OrderInventoryID', direction: orderByDirection }];
        case 'ColliInventoryID':
            return [{ field: 'Colli.ColliInventoryID', direction: orderByDirection }];
        case 'ProductType':
            return [{ field: 'Type', direction: orderByDirection }];
        default:
            return [{ field: field, direction: orderByDirection }];
    }
};

export const goToMobileProduct = (event, customerID, name, activeCustomer, redirectOptions, setRedirectOptions) => {
    let mobileProductInventoryID = event.currentTarget.value;
    if (customerID !== activeCustomer) {
        setRedirectOptions({ ...redirectOptions, open: true, product: name, customerID: customerID });
        return;
    }
    createHistory();
    setRedirectOptions({
        ...redirectOptions,
        redirect: true,
        mobileProductInventoryID: event.currentTarget.value,
        redirectPath: `/products/mobile-products?InventoryID=${mobileProductInventoryID}`
    });
};

export const goToDisplayProduct = (event, customerID, name, activeCustomer, redirectOptions, setRedirectOptions) => {
    let displayProductInventoryID = event.currentTarget.value;
    if (customerID !== activeCustomer) {
        setRedirectOptions({ ...redirectOptions, open: true, product: name, customerID: customerID });
        return;
    }
    createHistory();
    setRedirectOptions({
        ...redirectOptions,
        redirect: true,
        displayProductInventoryID: event.currentTarget.value,
        redirectPath: `/products/displayProducts?InventoryID=${displayProductInventoryID}`
    });
};
export const goToStorageProduct = (event, customerID, name, activeCustomer, redirectOptions, setRedirectOptions) => {
    let storageProductInventoryID = event.currentTarget.value;
    if (customerID !== activeCustomer) {
        setRedirectOptions({ ...redirectOptions, open: true, product: name, customerID: customerID });
        return;
    }
    createHistory();
    setRedirectOptions({
        ...redirectOptions,
        redirect: true,
        storageProductInventoryID: event.currentTarget.value,
        redirectPath: `/products/storage-products?InventoryID=${storageProductInventoryID}`
    });
};

export const goToPcProduct = (event, customerID, name, activeCustomer, redirectOptions, setRedirectOptions) => {
    let pcProductInventoryID = event.currentTarget.value;
    if (customerID !== activeCustomer) {
        setRedirectOptions({ ...redirectOptions, open: true, product: name, customerID: customerID });
        return;
    }
    createHistory();
    setRedirectOptions({
        ...redirectOptions,
        redirect: true,
        pcProductInventoryID: event.currentTarget.value,
        redirectPath: `/products/pc-products?InventoryID=${pcProductInventoryID}`
    });
};
export const isValidJSONString = (str) => {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

export const getEraseStatus = (status, translations, forStyle) => {
    switch (status) {
        case 'erased':
            return forStyle ? 'Erased' : translations['erased'] || 'Erased';
        case 'noterased':
            return forStyle ? 'NotErased' : translations['not_erased'] || 'Not erased';
        case 'inprogress':
            return forStyle ? 'InProgress' : translations['in_progress'] || 'In progress';
        case 'error':
            return forStyle ? 'Error' : translations['error'] || 'Error'
        case 'warning':
            return forStyle ? 'Warning' : translations['warning'] || 'Warning';
        case 'aborted':
            return forStyle ? 'Aborted' : translations['aborted_by_user'] || 'Aborted by user';
        case 'started':
            return forStyle ? 'Started' : translations['started'] || 'Started';
        default:
            return forStyle ? 'NotErased' : translations['not_erased'] || 'Not erased';
    }
};

export const getVerificationStatus = (status, translations, forStyle) => {
    switch (status) {
        case 'verified':
            return forStyle ? 'Erased' : translations['verified'] || 'Verified';
        case 'notverified':
            return forStyle ? 'NotErased' : translations['not_verified'] || 'Not verified';
        case 'inprogress':
            return forStyle ? 'InProgress' : translations['in_progress'] || 'In progress';
        case 'error':
            return forStyle ? 'Error' : translations['error'] || 'Error'
        case 'warning':
            return forStyle ? 'Warning' : translations['warning'] || 'Warning';
        case 'aborted':
            return forStyle ? 'Aborted' : translations['aborted_by_user'] || 'Aborted by user';
        case 'started':
            return forStyle ? 'Started' : translations['started'] || 'Started';
        default:
            return forStyle ? 'NotErased' : translations['not_verified'] || 'Not verified';
    }
};

export const getFormatWipeStarted = (components, field = 'WipeStarted') => {
    if (components) {
        let prettyPrint = components?.length < 4 ? components.map(component => {
            return <Typography key={`${component?.ComponentID}_${parseInt(Math.random() * 99999)}`}
                style={{ fontSize: 12 }}
                gutterBottom>{component?.StorageComponents[0] && formatDate(component?.StorageComponents[0][field])}</Typography>
        }) : <>
                <Typography key={`${components[0] && components[0]?.ComponentID}_${parseInt(Math.random() * 99999)}`}
                    style={{ fontSize: 12 }}
                    gutterBottom>{components[0] && components[0]?.StorageComponents[0] && formatDate(components[0]?.StorageComponents[0][field])}</Typography>
                <Typography key={`${components[1]?.ComponentID}_${parseInt(Math.random() * 99999)}`}
                    style={{ fontSize: 12 }}
                    gutterBottom>{components[1] && components[1]?.StorageComponents[0] && formatDate(components[1]?.StorageComponents[0][field])}</Typography>
                <Typography key={`${components[2]?.ComponentID}_${parseInt(Math.random() * 99999)}`}
                    style={{ fontSize: 12 }}
                    gutterBottom>{components[2] && components[2]?.StorageComponents[0] && formatDate(components[2]?.StorageComponents[0][field])}</Typography>
            </>
        return (prettyPrint);
    }
}

export const getDiagnoseStatus = (data, translations) => {

    let inProgress = 0;
    let passed = 0;
    let failed = 0;
    let aborted = 0;
    let skipped = 0;
    let notStarted = 0;
    let started = 0;

    for (var diagnoseData of data) {
        switch (diagnoseData.Status) {
            case 'passed':
                passed++;
                break;
            case 'inprogress':
                inProgress++;
                break;
            case 'failed':
                failed++;
                break;
            case 'skipped':
                skipped++;
                break;
            case 'notstarted':
                notStarted++;
                break;
            case 'aborted':
                aborted++;
                break;
            case 'started':
                started++;
                break;
            default:
                notStarted++;
                break;
        }
    }
    return <>
        {passed > 0 ? <CustomChip key='erasedChipStatus' className={'chip_Erased'} value={`${translations["passed"] || "Passed"}: ${passed}`} /> : null}
        {inProgress > 0 ? <CustomChip key='notErasedChipStatus' className={'chip_InProgress'} value={`${translations["in_progress"] || 'In progress'}: ${inProgress}`} /> : null}
        {failed > 0 ? <CustomChip key='inProgressChipStatus' className={'chip_NotErased'} value={`${translations["failed"] || 'Failed'}: ${failed}`} /> : null}
        {skipped > 0 ? <CustomChip key='warningChipStatus' className={'chip_Warning'} value={`${translations["skipped"] || "Skipped"}: ${skipped}`} /> : null}
        {notStarted > 0 ? <CustomChip key='notErasedChipStatus' className={'chip_NotStarted'} value={`${translations["not_started"] || "Not started"} : ${notStarted}`} /> : null}
        {aborted > 0 ? <CustomChip key='abortedChipStatus' className={'chip_Aborted'} value={`${translations["aborted_by_user"] || "Aborted by user"} : ${aborted}`} /> : null}
        {started > 0 ? <CustomChip key='startedChipStatus' className={'chip_Started'} value={`${translations["started"] || "Started"} : ${started}`} /> : null}
        {!passed && !inProgress && !failed && !skipped && !notStarted && !aborted && !started ? <CustomChip key='noStoragesChipStatus' className={'chip_InProgress'} value={`n/a`} /> : null}

    </>
}
